import React, { useState } from 'react'
import {makeStyles} from '@material-ui/core'
import {Drawer, Input, Form} from 'antd'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import PropTypes from 'prop-types'


const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

/**
 * Drawer with form inputs to create new users for the admin.
 * 
 * Fill in all the required fields and submit.
 */
const NewUser = ({visible, close}) => {
    const [error, setError] = useState(null)
    const [form] = Form.useForm()

    const classes = useStyles()
    const data = useData()
    const users = data.users()

    // create a user 
    const createUser = details => {
        const {password, password_confirm} = details 

        if(password !== password_confirm){
            form.setFields({
                password_confirm: {
                    error: [new Error("Password do not match")]
                }
            })
        }
        trackPromise(
            users.createUser(details)
                .then(close)
                .catch(err => {
                    console.log(err.message)
                    setError("An error occured")
                })
        )
    }

    const {promiseInProgress} = usePromiseTracker()

    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Create a User"
        >
            <Form
                layout="vertical"
                onFinish={createUser}
                form={form}
            >
                <Form.Item label="Email" name="email" rules={[{required: true, message: " Email is required"}]}>
                    <Input />
                </Form.Item>
                <Form.Item label="First name" name="first_name" rules={[{required: true, message: "First name is required"}]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Last name" name="last_name" rules={[{required: true, message: "Last name is required"}]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Password" name="password" rules={[{required: true, message: "Password is required"}]}>
                    <Input.Password />
                </Form.Item>
                <Form.Item label="Confirm password" name="password_confirm" rules={[{required: true, message: "Confirmation is required"}]}>
                    <Input.Password />
                </Form.Item>
                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item> 
                    )
                }
            </Form>
        </Drawer>
    )
}

NewUser.propTypes = {
    /** Control the visibility of the drawer in view port */
    visible: PropTypes.bool,
    /** Hide the drawer from view */
    close: PropTypes.func
}

export default NewUser 